module.exports = __webpack_public_path__ + "static/media/google.527196e0.jpg";